// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1Fqci","list":"BalanceDue_list__1WiNf","listRow":"BalanceDue_listRow__ezyBK","total":"BalanceDue_total__24Q5R"};